import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-rename-file-modal',
  templateUrl: './rename-file-modal.component.html',
  styleUrl: './rename-file-modal.component.scss',
  standalone: false,
})
export class RenameFileModalComponent {
  public form: FormGroup = new FormGroup({
    fileName: new FormControl('', [
      Validators.required,
      Validators.minLength(1),
    ]),
  });

  public currentFileName: string;
  public fileExtension: string = '';

  constructor(
    private dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {
    this.currentFileName = this.config.data?.currentFileName || '';

    // Extract extension and name without extension
    const parts = this.currentFileName.split('.');
    if (parts.length > 1) {
      this.fileExtension = parts.pop()!;
      const nameWithoutExt = parts.join('.');
      this.form.patchValue({ fileName: nameWithoutExt });
    } else {
      this.form.patchValue({ fileName: this.currentFileName });
    }
  }

  onRename(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const newName = this.form.get('fileName')?.value?.trim();
    if (!newName) return;

    this.dialogRef.close(newName); // Extension will be added by the caller
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
